import * as $ from 'jquery';

export class ImageCommon {
    static init() {
        $(document).off('click', '.link-image');
        $(document).on('click', '.link-image', ev => {
            let target = $(ev.target).closest('[data-image-link]');
            if (target.length) {
                let url = target.eq(0).attr('data-image-link');
                if (url) {
                    let targetWindow = '_blank';
                    if(target.closest('.viva-wrapper').length){
                        targetWindow='_self';
                    }
                    var win = window.open(url, targetWindow);
                    win.focus();
                }
            }
        })
    }

    static isDefault(image) {
        return image.indexOf(ImageCommon.defaultImage) > -1;
    }
    static isDefaultPath(imagePath) {
        return imagePath == ImageCommon.defaultImagePath;
    }

    static defaultImagePath = './page-builder/public/assets/component/placeholder4.png';
    static defaultImage = `<img src=${ImageCommon.defaultImagePath} />`

}